export default "__VITE_ASSET__DDPKi3Q1__"